module.exports = __webpack_public_path__ + "media/images/emblems/Belmont-sur-Yverdon-coat_of_arms-1a475390fc02beacf21a484f75f57dd6.svg";